/*
  Переход по названию пункта меню, у которого есть вложенные.

  Тема делает такой пункт раскрывающимся списком, и клик по нему только
  открывает список. Название теперь ссылка, но она лежит внутри `summary`, а
  клик по `summary` браузер сам превращает в раскрытие. Поэтому по ссылке
  раскрытие отменяем и уходим по адресу; стрелка рядом продолжает раскрывать.
*/
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-parent-link]');
  if (!link) return;
  event.preventDefault();
  event.stopPropagation();
  window.location.href = link.href;
});

/* С клавиатуры `summary` открывается по Enter — оставляем это поведение,
   но на самой ссылке Enter должен вести на страницу. */
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter') return;
  const link = event.target.closest('a[data-parent-link]');
  if (!link) return;
  event.preventDefault();
  window.location.href = link.href;
});
